import { API_SERVICEPROVIDERS_BACKEND, API_USERS_BACKEND } from "../../../../api/api";
import { selectClientID } from "../../../../context/slices/loggedInClientSlice";
import { ACTION_toggleRefreshSwitch } from "../../../../context/slices/refreshSwitch";
import { thankYouModalActions } from "../../../../context/slices/thankYouModalSlice";
import {
  selectLoggedInClientAssignment,
} from "../../../../context/slices/userProfileSlice";
import { useXNGDispatch, useXNGSelector } from "../../../../context/store";
import { ServiceProviderRef } from "../../../../profile-sdk";
import useRefetchUnpostedSessionsRequests from "../../../../views/unposted_sessions/hooks/use_refetch_unposted_sessions_requests";
import { ACTION_addProviderToSupervisedCaseload } from "../../../../context/slices/userProfileSlice";
import { CaseloadType } from "@xng/xng-backend";

export function useAddProviderToApproverCaseload() {
  const dispatch = useXNGDispatch();
  const clientID = useXNGSelector(selectClientID);
  const loggedInClientAssignment = useXNGSelector(selectLoggedInClientAssignment);
  const { refetchOnCaseloadAction } = useRefetchUnpostedSessionsRequests();

  async function addToApproverCaseload(serviceProvider: ServiceProviderRef) {
    const spId = loggedInClientAssignment.serviceProviderProfile?.id;
    if (!serviceProvider?.id || !clientID || !spId) {
      console.error("Insufficient data provided to 'addProviderToApproverCaseload'!");
      return;
    }

    const memberUser = await API_USERS_BACKEND
      .getUserByServiceProvider({
        serviceProviderId: serviceProvider.id,
        clientId: clientID,
      });
    if (!memberUser.id) throw new Error("Could not resolve user for service provider");

    const updatedCaseload = await API_SERVICEPROVIDERS_BACKEND
      .postCaseload({
        serviceProviderId: spId,
        caseloadType: CaseloadType.NUMBER_1,
        postCaseloadBody: { memberId: memberUser.id },
      });

    const mappedProviders: ServiceProviderRef[] = updatedCaseload.map((r) => ({
      id: r.id,
      firstName: r.firstName,
      lastName: r.lastName,
      email: r.email,
    }));

    dispatch(
      ACTION_addProviderToSupervisedCaseload({
        providers: mappedProviders,
        loggedinClientId: clientID,
      }),
    );

    refetchOnCaseloadAction();
    dispatch(ACTION_toggleRefreshSwitch());
    dispatch(
      thankYouModalActions.ACTION_ShowThankyouModal({
        show: true,
        text: `You can now access ${serviceProvider.firstName} ${serviceProvider.lastName}'s account 
      by navigating to “My Profile” in the 
      navigation bar.`,
      }),
    );
  }

  return addToApproverCaseload;
}
